import { useNavigate } from "react-router";
import { IsLoged, USER_ID } from "../../App";
import { useEffect, useState } from "react";
import { Layout } from "../../Globalstyles/Layout";
import Menu from "../../components/Menu";
import { Container, InfoModal } from "./styles";
import { db } from "../../server";
import { BiTrash, BiUserPlus, BiX } from "react-icons/bi";

export default function UserManager() {
	const navigate = useNavigate();

	const [loadListUser, setLoadListUser] = useState(false);

	const [userList, setUserList] = useState([]);
	const [adding, setAdding] = useState(false);
	const [viewInfo, setViewInfo] = useState(false);
	const [tempUserName, setTUN] = useState("");
	const [tempUserMail, setTUM] = useState("");

	const [userName, setUserName] = useState("");
	const [userMail, setUserMail] = useState("");
	const [isAdmin, setIsAdmin] = useState(false);

	const DefaultPassword = "mudar@senha";

	useEffect(() => {
		if (!IsLoged()) return navigate("/login");
	});

	function loadUsers() {
		const dbRef = db.collection("usuarios");

		dbRef.get().then((doc) => {
			if (!doc.empty) {
				const users = doc.docs.map((u) => ({
					id: u.id,
					...u.data(),
				}));

				setUserList(users);
			}
		});
	}

	useEffect(() => {
		if (!loadListUser) {
			loadUsers();
			setLoadListUser(true);
		}
	}, [loadListUser]);

	async function removeUser({ userID }) {
		let admin = false;

		const u = await db.collection("usuarios").doc(USER_ID()).get();
		if (u.exists && u.data().type === 1) {
			admin = true;
		}
		if (admin) {
			try {
				await db.collection("usuarios").doc(userID).delete();
				setLoadListUser(false);
				alert(`Usuário com ID: ${userID} excluído com sucesso!`);
			} catch (err) {
				console.error("Erro ao excluir usuário:", err);
				alert("Erro ao excluir usuário. Verifique o console.");
			}
		} else {
			alert("Você precisa ser um administador para executar essa ação!");
		}
	}

	async function addUser() {
		if (userName === "" || userMail === "")
			return alert("Preencha todos os campos");

		const dbRef = db.collection("usuarios");

		let admin = false;

		const u = await db.collection("usuarios").doc(USER_ID()).get();
		if (u.exists && u.data().type === 1) {
			admin = true;
		}
		if (admin) {
			// Verifica se já existe usuário com o mesmo e-mail
			const existingUser = await dbRef.where("mail", "==", userMail).get();

			if (!existingUser.empty) {
				alert("Já existe um usuário cadastrado com esse e-mail.");
				return;
			}

			let fullName = userName;
			setTUN(fullName);
			setTUM(userMail);

			await dbRef.add({
				user: userName.replace(/\s+/g, ""),
				fullName,
				mail: userMail,
				password: DefaultPassword,
				type: isAdmin ? 1 : -1,
				firstAccess: true,
			});
			setViewInfo(true);
		} else {
			setViewInfo(false);
			alert("Você precisa ser um administador para executar essa ação!");
		}

		setUserName("");
		setUserMail("");
		setAdding(false);
		setLoadListUser(false);
	}

	return (
		<div className="app" style={{ maxHeight: "100vh", overflow: "hidden" }}>
			<Layout className="layout">
				<Menu />
				<Container className="MC">
					<h1>Gerenciamento de usuários</h1>

					<div className="actions-area">
						<div className="userlist">
							<h2>Lista de usuários:</h2>
							<ul>
								<div className="list">
									{!userList.length ? (
										<>
											<p>nenhum usuario adicionado!</p>
										</>
									) : (
										userList.map((u) => (
											<>
												<li key={u.id}>
													<div>
														{u.fullName || u.user} (
														{u.type === 1 ? "Adminstrador" : "Redator"})
													</div>
													<button
														onClick={() => {
															removeUser({ userID: u.id });
														}}>
														<BiTrash />
													</button>
												</li>
											</>
										))
									)}
								</div>

								<div className="button-wrapper">
									<button
										onClick={() => {
											setAdding(true);
											setViewInfo(false);
										}}>
										Adicionar usuários <BiUserPlus />
									</button>
								</div>
							</ul>
						</div>

						<div className="addind-wrapper">
							<div className={!adding ? "close-add_area" : "add_area"}>
								<h2>Criando Usuario:</h2>
								<div>
									<div className="input-area">
										<label htmlFor="name">Nome</label>
										<input
											type="text"
											id="name"
											placeholder="Nome do usuário..."
											value={userName}
											onChange={(e) => setUserName(e.target.value)}
										/>
									</div>
									<br />
									<div className="input-area">
										<label htmlFor="mail">E-mail</label>
										<input
											type="email"
											id="mail"
											placeholder="E-mail do usuário..."
											value={userMail}
											onChange={(e) => setUserMail(e.target.value)}
										/>
									</div>
									<br />
									<div className="input-area checkbox-area">
										<input
											type="checkbox"
											id="admin"
											value={isAdmin}
											onChange={() => setIsAdmin(!isAdmin)}
										/>
										<label htmlFor="admin">Administrador</label>
									</div>
								</div>
								<button onClick={() => addUser()}>Adicionar</button>
							</div>
						</div>
					</div>
					<InfoModal className={!viewInfo ? "closeModal" : ""}>
						<ul>
							<li key="username">
								Login: {tempUserName} | {tempUserMail}
							</li>
							<li key="usermail">
								Senha: {DefaultPassword}
								<br />
								(senha será alterada pelo usuário no primeiro acesso!)
							</li>

							<button onClick={() => setViewInfo(!viewInfo)}>
								fechar
								<BiX />
							</button>
						</ul>
					</InfoModal>
				</Container>
			</Layout>
		</div>
	);
}
